import styled, { css } from 'styled-components';

export const Container = styled.div<{ isHidden: boolean; size: string }>`
  background-color: ${props => props.theme.colors.capsuleGray00};
  width: 100vw;
  border: 0.1px solid ${props => props.theme.colors.capsuleGray00};

  ${props =>
    props.size === 'small' &&
    css`
      height: 4px;
    `}

  ${props =>
    props.size === 'large' &&
    css`
      height: 8px;
    `}

  ${props =>
    props.isHidden &&
    css`
      display: none;
    `}
`;

export const Bar = styled.div<{ fill: number | string; hasLargeBorderRadius: boolean }>`
  background-color: ${props => props.theme.colors.capsuleGreen60};
  border-radius: 0 ${props => (props.hasLargeBorderRadius ? '12px' : props.theme.radii.small)}
    ${props => (props.hasLargeBorderRadius ? '12px' : props.theme.radii.small)} 0;
  height: 100%;
  width: ${props => props.fill}%;
  transition: width 500ms ease-in;
`;
